import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Sparkles } from 'lucide-react';
import { RECOMMENDED_VIDEOS_QUERY, type VideoListItem } from '../shared/index.ts';
import { VideoRow, VideoListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/videos',          label: 'For You', end: true },
  { to: '/videos/latest',   label: 'Latest' },
  { to: '/videos/channels', label: 'Channels' },
  { to: '/videos/seen',     label: 'Watched' },
  { to: '/videos/saved',    label: 'Saved' },
];

export function VideosForYou() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['videos', 'for-you'],
    queryFn: async () => {
      const res = await gql.request<{ recommendedVideos: VideoListItem[] }>(RECOMMENDED_VIDEOS_QUERY);
      return res.recommendedVideos;
    },
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Videos" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <VideoListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load recommendations." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Sparkles size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">Personalised videos are building up — check back soon.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {data.map((v) => <VideoRow key={v.id} v={v} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
